export const getStatusColor = status => {
	switch(status.toLowerCase()) {
		case 'свободно': return {
			label: 'Свободно',
			color: 'apple'
		}
		case 'свободна': return {
			label: 'Свободна',
			color: 'apple'
		}
    case 'свободный': return {
      label: 'Свободный',
      color: 'apple'
    }
		case 'available': return {
			label: 'Available',
			color: 'apple'
		}
    case 'продадено': return {
      label: 'Продадено',
      color: 'monza'
    }
    case 'продадена': return {
      label: 'Продадена',
      color: 'monza'
    }
    case 'проданный': return {
      label: 'Проданный',
      color: 'monza'
    }
		case 'sold': return {
			label: 'Sold',
			color: 'monza'
		}
    case 'резервирано': return {
      label: 'Резервирано',
      color: 'buddha'
    }
    case 'резервирана': return {
      label: 'Резервирана',
      color: 'buddha'
    }
    case 'зарезервированный': return {
      label: 'Зарезервированный',
      color: 'buddha'
    }
		case 'reserved': return {
			label: 'Reserved',
			color: 'buddha'
		}
		default: return {
			label: 'Свободно',
			color: 'apple'
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/parking.js